import { render, staticRenderFns } from "./PostFeedInternal.vue?vue&type=template&id=d6c297e6&"
import script from "./PostFeedInternal.vue?vue&type=script&lang=js&"
export * from "./PostFeedInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports